import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

export const ScrollTopButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed bottom-28 sm:bottom-8 right-6 sm:right-8 z-[60] w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
      style={{ backgroundColor: '#7B4FD8', color: '#FFF' }}
      aria-label="Scroll to top"
      data-testid="scroll-to-top-btn"
    >
      <ArrowRight size={20} className="-rotate-90" />
    </button>
  );
};

export default ScrollTopButton;
